import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface BlogPost {
  id: number;
  image: string;
  author: string;
  date: string;
  title: string;
  excerpt: string;
  category: string;
}

const Blog: React.FC = () => {
  const [blogs] = useState<BlogPost[]>([
    {
      id: 1,
      image: '/img/blog-1.jpg',
      author: 'Admin',
      date: '01 Jan 2045',
      title: 'How to build a website',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates. Quisquam, voluptates.',
      category: 'Web Development'
    },
    {
      id: 2,
      image: '/img/blog-2.jpg',
      author: 'Admin',
      date: '05 Jan 2045',
      title: 'Best practices for UI/UX design',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates.',
      category: 'Design'
    },
    {
      id: 3,
      image: '/img/blog-3.jpg',
      author: 'Admin',
      date: '10 Jan 2045',
      title: 'Digital marketing strategies',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates.',
      category: 'Marketing'
    },
    {
      id: 4,
      image: '/img/blog-1.jpg',
      author: 'Admin',
      date: '15 Jan 2045',
      title: 'Mobile app development trends',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates.',
      category: 'Mobile Apps'
    },
    {
      id: 5,
      image: '/img/blog-2.jpg',
      author: 'Admin',
      date: '20 Jan 2045',
      title: 'SEO optimization techniques',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates.',
      category: 'SEO'
    },
    {
      id: 6,
      image: '/img/blog-3.jpg',
      author: 'Admin',
      date: '25 Jan 2045',
      title: 'Cloud computing benefits',
      excerpt: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quisquam. Excepturi, voluptates.',
      category: 'Technology'
    }
  ]);

  const categories = ['All', 'Web Development', 'Design', 'Marketing', 'Mobile Apps', 'SEO', 'Technology'];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredBlogs = activeCategory === 'All' 
    ? blogs 
    : blogs.filter(blog => blog.category === activeCategory);

  return (
    <div className="blog-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">Latest Blog Posts</h1>
          <nav className="flex justify-center animate-fadeInUp">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Blog</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Blog Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Blog List */}
            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {filteredBlogs.map((blog, index) => (
                  <div 
                    key={blog.id}
                    className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 animate-fadeInUp"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="relative overflow-hidden">
                      <img 
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-48 object-cover transform hover:scale-110 transition duration-500"
                      />
                      <div className="absolute top-4 left-4 bg-secondary text-white px-3 py-1 rounded-full text-sm">
                        {blog.category}
                      </div>
                    </div>
                    <div className="p-6">
                      <div className="flex items-center text-sm text-gray-500 mb-3">
                        <i className="far fa-user mr-2 text-secondary"></i>
                        <span className="mr-4">{blog.author}</span>
                        <i className="far fa-calendar-alt mr-2 text-secondary"></i>
                        <span>{blog.date}</span>
                      </div>
                      <h4 className="text-xl font-bold mb-3 hover:text-secondary transition cursor-pointer">
                        {blog.title}
                      </h4>
                      <p className="text-gray-600 mb-4">{blog.excerpt}</p>
                      <Link to={`/blog/${blog.id}`} className="text-secondary hover:text-primary font-semibold">
                        Read More <i className="fas fa-arrow-right ml-2"></i>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div className="flex justify-center mt-12">
                <nav className="flex space-x-2">
                  <button className="bg-white border border-gray-300 hover:bg-primary hover:text-white hover:border-primary w-10 h-10 rounded flex items-center justify-center transition">
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <button className="bg-primary text-white w-10 h-10 rounded flex items-center justify-center">1</button>
                  <button className="bg-white border border-gray-300 hover:bg-primary hover:text-white hover:border-primary w-10 h-10 rounded flex items-center justify-center transition">2</button>
                  <button className="bg-white border border-gray-300 hover:bg-primary hover:text-white hover:border-primary w-10 h-10 rounded flex items-center justify-center transition">3</button>
                  <button className="bg-white border border-gray-300 hover:bg-primary hover:text-white hover:border-primary w-10 h-10 rounded flex items-center justify-center transition">
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </nav>
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-4">
              {/* Search Widget */}
              <div className="bg-white rounded-lg shadow-lg p-6 mb-8 animate-fadeInRight">
                <h4 className="text-xl font-bold mb-4">Search</h4>
                <div className="relative">
                  <input 
                    type="text" 
                    placeholder="Search..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                  <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-secondary transition">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>

              {/* Categories Widget */}
              <div className="bg-white rounded-lg shadow-lg p-6 mb-8 animate-fadeInRight" style={{ animationDelay: '0.2s' }}>
                <h4 className="text-xl font-bold mb-4">Categories</h4>
                <div className="space-y-2">
                  {categories.map((category, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveCategory(category)}
                      className={`w-full text-left px-4 py-2 rounded transition ${
                        activeCategory === category
                          ? 'bg-primary text-white'
                          : 'hover:bg-gray-100 text-gray-700'
                      }`}
                    >
                      <i className="fas fa-angle-right mr-2 text-secondary"></i>
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              {/* Recent Posts Widget */}
              <div className="bg-white rounded-lg shadow-lg p-6 mb-8 animate-fadeInRight" style={{ animationDelay: '0.4s' }}>
                <h4 className="text-xl font-bold mb-4">Recent Posts</h4>
                <div className="space-y-4">
                  {blogs.slice(0, 4).map((blog) => (
                    <div key={blog.id} className="flex items-start group cursor-pointer">
                      <img 
                        src={blog.image}
                        alt={blog.title}
                        className="w-16 h-16 object-cover rounded mr-3"
                      />
                      <div className="flex-1">
                        <h6 className="font-semibold text-sm group-hover:text-secondary transition line-clamp-2">
                          {blog.title}
                        </h6>
                        <span className="text-xs text-gray-500">
                          <i className="far fa-calendar-alt mr-1"></i>
                          {blog.date}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tags Widget */}
              <div className="bg-white rounded-lg shadow-lg p-6 mb-8 animate-fadeInRight" style={{ animationDelay: '0.6s' }}>
                <h4 className="text-xl font-bold mb-4">Popular Tags</h4>
                <div className="flex flex-wrap gap-2">
                  {['Web Design', 'Marketing', 'SEO', 'Development', 'Technology', 'UI/UX', 'Mobile', 'Business'].map((tag, index) => (
                    <button
                      key={index}
                      className="px-4 py-2 border border-gray-300 rounded hover:bg-primary hover:text-white hover:border-primary transition text-sm"
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </div>

              {/* Newsletter Widget */}
              <div className="bg-primary rounded-lg shadow-lg p-6 text-white animate-fadeInRight" style={{ animationDelay: '0.8s' }}>
                <h4 className="text-xl font-bold mb-4">Newsletter</h4>
                <p className="mb-4 text-sm">Subscribe to get latest updates and news</p>
                <input 
                  type="email" 
                  placeholder="Your email"
                  className="w-full px-4 py-3 rounded-lg mb-3 text-gray-800 focus:outline-none"
                />
                <button className="w-full bg-secondary hover:bg-white hover:text-primary text-white font-semibold py-3 rounded-lg transition">
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;